import { setRooms, setSearchBox } from "./roommap";

(async function () {
    setRooms();
    setSearchBox();
})();
